module.exports = __webpack_public_path__ + "img/ic_favorited_sparks.11c286ec.png";